/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from 'react';

export default function useFetch<DataT, ErrorT = any>(fetch: () => Promise<DataT>, deps?: readonly any[]) {
  const [data, setData] = useState<DataT | undefined>(undefined);
  const [error, setError] = useState<ErrorT | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  const doFetch = useMemo(
    () => () => {
      let cancelled = false;
      setLoading(true);
      fetch().then(
        result => {
          if (!cancelled) {
            setData(result);
            setError(undefined);
            setLoading(false);
          }
        },
        err => {
          if (!cancelled) {
            setError(err as ErrorT);
            setLoading(false);
          }
        },
      );

      return () => {
        cancelled = true;
      };
    },
    deps,
  );
  useEffect(doFetch, deps || []);

  return {
    data,
    error,
    loading,
    refresh: doFetch,
    setData,
  };
}
